// extracted by mini-css-extract-plugin
module.exports = {"grid":"style__grid__fVKv6","table":"style__table__7nPYo","center":"style__center__b-kjn","group":"style__group__HqzQb","title":"style__title__vhkLm"};